/* JHERR · Carrito lateral fluido.
   Antes, al agregar un reloj, el carrito se redibujaba dos o tres veces (tema + scripts propios)
   y la foto se recargaba: se veía un pestañeo. Ahora:
   1) Al agregar, se pide solo el HTML del carrito (Section Rendering API) y el panel se abre
      cuando ya tiene el reloj nuevo, con su foto cargada.
   2) Cualquier redibujo del carrito se hace "por diferencia": lo que no cambió se queda tal cual
      (misma foto, sin recargar) y lo nuevo entra con un fade suave.
   No cambia precios, textos ni el funcionamiento del carrito. */
(function () {
  'use strict';
  if (window.__jhCartSmooth) return;
  window.__jhCartSmooth = true;

  var DRAWER = '#CartDrawer';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Estilos del fade ---------- */
  var css = document.createElement('style');
  css.textContent =
    DRAWER + ' .jh-morph-in{animation:jhMorphIn .4s cubic-bezier(.2,.7,.2,1) both}' +
    '@keyframes jhMorphIn{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}' +
    DRAWER + ' .cart__image .image-element{opacity:1!important;animation:none!important}' +
    DRAWER + ' .jh-cart-change-error{margin:0 20px 12px;color:#a12622;font-size:12px;line-height:1.4}' +
    '@media (prefers-reduced-motion:reduce){' + DRAWER + ' .jh-morph-in{animation:none}}';
  document.head.appendChild(css);

  /* ---------- Utilidades ---------- */
  function normUrl(u) {
    return String(u || '')
      .replace(/^https?:/, '')
      .replace(/\?.*$/, '')
      .replace(/_(\d+x\d+|\d+x|x\d+|pico|icon|thumb|small|compact|medium|large|grande|master)(?=\.)/i, '')
      .trim();
  }
  function imgUrl(img) {
    var ds = img.getAttribute('data-cart-defer-src') || img.getAttribute('data-src') || '';
    if (ds && ds.indexOf('data:') !== 0) return ds;
    return img.getAttribute('src') || '';
  }
  function keyOf(el) {
    if (el.nodeType !== 1) return null;
    if (el.hasAttribute('data-key')) return 'k:' + el.getAttribute('data-key');
    if (el.id) return 'i:' + el.id;
    return null;
  }
  /* Clases que ponen los scripts del tema al cargar (no vienen en el HTML nuevo): se conservan */
  var KEEP = { 'aos-init': 1, 'aos-animate': 1, 'loaded': 1, 'lazyloaded': 1, 'is-loaded': 1, 'image-loaded': 1, 'jh-morph-in': 1 };
  function baseClass(el) {
    return (el.getAttribute('class') || '').split(/\s+/).filter(function (c) { return c && !KEEP[c]; }).join(' ');
  }
  function looseMatch(a, b) {
    if (a.nodeType !== b.nodeType) return false;
    if (a.nodeType !== 1) return true;
    if (a.tagName !== b.tagName || keyOf(a) !== keyOf(b)) return false;
    return !!keyOf(a) || baseClass(a) === baseClass(b);
  }

  /* ---------- Fusión del DOM: solo cambia lo que cambió ---------- */
  function syncAttrs(oldEl, newEl) {
    var i, a;
    for (i = oldEl.attributes.length - 1; i >= 0; i--) {
      a = oldEl.attributes[i].name;
      if (a !== 'class' && !newEl.hasAttribute(a)) oldEl.removeAttribute(a);
    }
    for (i = 0; i < newEl.attributes.length; i++) {
      a = newEl.attributes[i];
      if (a.name === 'class') continue;
      if (oldEl.getAttribute(a.name) !== a.value) oldEl.setAttribute(a.name, a.value);
    }
    var keep = (oldEl.getAttribute('class') || '').split(/\s+/).filter(function (c) { return KEEP[c]; });
    var next = baseClass(newEl).split(' ').filter(Boolean).concat(keep);
    var want = next.filter(function (c, j) { return next.indexOf(c) === j; }).join(' ');
    if ((oldEl.getAttribute('class') || '') !== want) {
      if (want) oldEl.setAttribute('class', want); else oldEl.removeAttribute('class');
    }
  }

  function morphImg(oldImg, newImg) {
    var same = normUrl(imgUrl(oldImg)) === normUrl(imgUrl(newImg));
    if (same && oldImg.complete && oldImg.naturalWidth > 0) return; /* misma foto ya cargada: no se toca */
    syncAttrs(oldImg, newImg);
  }

  function morphNode(oldN, newN) {
    if (oldN.nodeType === 3 || oldN.nodeType === 8) {
      if (oldN.nodeValue !== newN.nodeValue) oldN.nodeValue = newN.nodeValue;
      return;
    }
    if (oldN.classList.contains('cart__item') && removals.has(oldN.getAttribute('data-key'))) return;
    if (oldN.tagName === 'IMG') { morphImg(oldN, newN); return; }
    if (oldN.tagName === 'SCRIPT' || oldN.tagName === 'IFRAME' || oldN.hasAttribute('data-jh-keep')) return;
    if (oldN.classList.contains('shopify-payment-button') || oldN.classList.contains('additional-checkout-buttons')) return;
    syncAttrs(oldN, newN);
    if (oldN.tagName === 'INPUT' || oldN.tagName === 'TEXTAREA' || oldN.tagName === 'SELECT') {
      if (document.activeElement !== oldN) {
        if (oldN.type === 'checkbox' || oldN.type === 'radio') oldN.checked = newN.hasAttribute('checked');
        else if (newN.hasAttribute('value') && oldN.value !== newN.getAttribute('value')) oldN.value = newN.getAttribute('value');
      }
      return;
    }
    morphChildren(oldN, newN);
  }

  function fadeIn(el) {
    if (el.nodeType !== 1 || /^(SCRIPT|STYLE|TEMPLATE|INPUT|LINK)$/.test(el.tagName)) return;
    var aos = [el].concat(Array.prototype.slice.call(el.querySelectorAll('[data-aos]')));
    aos.forEach(function (n) { if (n.hasAttribute('data-aos')) n.classList.add('aos-init', 'aos-animate'); });
    if (reduce) return;
    el.classList.add('jh-morph-in');
    el.addEventListener('animationend', function () { el.classList.remove('jh-morph-in'); }, { once: true });
  }

  function morphChildren(oldParent, newParent) {
    var oldKids = Array.prototype.slice.call(oldParent.childNodes);
    var newKids = Array.prototype.slice.call(newParent.childNodes);
    var used = new Set();
    var byKey = new Map();
    oldKids.forEach(function (n) { var k = keyOf(n); if (k) byKey.set(k, n); });
    var cursor = 0;
    var result = [];

    newKids.forEach(function (nn) {
      var match = null;
      var k = keyOf(nn);
      if (k) {
        match = byKey.get(k) || null;
        if (match && (used.has(match) || match.tagName !== nn.tagName)) match = null;
      } else {
        for (var i = cursor; i < oldKids.length; i++) {
          var on = oldKids[i];
          if (!used.has(on) && looseMatch(on, nn)) { match = on; cursor = i + 1; break; }
        }
      }
      if (match) {
        used.add(match);
        morphNode(match, nn);
        result.push(match);
      } else {
        var fresh = document.importNode(nn, true);
        fadeIn(fresh);
        result.push(fresh);
      }
    });

    oldKids.forEach(function (n) { if (!used.has(n) && n.parentNode === oldParent) oldParent.removeChild(n); });
    result.forEach(function (n, i) {
      var at = oldParent.childNodes[i];
      if (at !== n) oldParent.insertBefore(n, at || null);
    });
    while (oldParent.childNodes.length > result.length) oldParent.removeChild(oldParent.lastChild);
  }

  /* ---------- Todo redibujo del carrito pasa por la fusión ---------- */
  var desc = Object.getOwnPropertyDescriptor(Element.prototype, 'innerHTML');
  var nativeSet = desc.set;

  function morphHTML(el, html) {
    var tpl = document.createElement('template');
    nativeSet.call(tpl, html);
    morphChildren(el, tpl.content);
  }
  function shouldMorph(el, html) {
    if (!html || el.nodeType !== 1) return false;
    if (!(el.classList.contains('drawer__scrollable') || el.hasAttribute('data-products') || el.hasAttribute('data-cart-discounts'))) return false;
    return !!el.closest(DRAWER);
  }
  Object.defineProperty(Element.prototype, 'innerHTML', {
    configurable: true,
    enumerable: desc.enumerable,
    get: desc.get,
    set: function (html) {
      if (shouldMorph(this, html)) {
        try { morphHTML(this, html); return; } catch (e) { /* si algo falla, se hace como siempre */ }
      }
      nativeSet.call(this, html);
    }
  });

  /* ---------- Precarga de fotos nuevas antes de mostrarlas ---------- */
  function preload(root) {
    var jobs = [];
    root.querySelectorAll('img').forEach(function (img) {
      var ds = img.getAttribute('data-src');
      if (ds && (!img.getAttribute('src') || img.getAttribute('src').indexOf('data:') === 0)) img.setAttribute('src', ds.replace(/\{width\}/g, '180'));
      var dss = img.getAttribute('data-srcset');
      if (dss && !img.getAttribute('srcset')) img.setAttribute('srcset', dss.replace(/\{width\}/g, '180'));
      img.classList.remove('lazyload');
      var src = img.getAttribute('src') || '';
      if (!src || img.closest('.js-upsell-grid, .jh-addons')) return;
      img.setAttribute('loading', 'eager');
      var known = Array.prototype.some.call(document.querySelectorAll(DRAWER + ' img'), function (c) {
        return c.complete && c.naturalWidth > 0 && normUrl(c.getAttribute('src')) === normUrl(src);
      });
      if (known) return;
      var p = new Image();
      if (img.getAttribute('sizes')) p.sizes = img.getAttribute('sizes');
      if (img.getAttribute('srcset')) p.srcset = img.getAttribute('srcset');
      p.src = src;
      jobs.push((p.decode ? p.decode() : Promise.resolve()).catch(function () {}));
    });
    return Promise.race([Promise.all(jobs), new Promise(function (r) { setTimeout(r, 120); })]);
  }

  function sectionId() {
    var d = document.querySelector(DRAWER);
    var s = d && d.closest('.shopify-section');
    return s && s.id ? s.id.replace(/^shopify-section-/, '') : null;
  }

  /* ---------- Integración con el tema (Impulse) ---------- */
  var pending = null;
  var pdpAdding = false;
  var renderedAddition = false;
  var removals = new Map();
  var removalCount = 0;
  var checkoutState = [];
  var activeCartForm = null;
  var firstBuild = true;
  var recentEvent = false;
  function mark() { recentEvent = true; setTimeout(function () { recentEvent = false; }, 3000); }
  window.addEventListener('ajaxProduct:added', mark, true);
  window.addEventListener('cart:build', mark, true);

  /* Pide el carrito: primero la sección liviana (sections/jherr-cart-body), si no existe, la cabecera */
  function fetchDrawer(path, sid) {
    var url = new URL(path, window.location.origin);
    var t = window.Shopify && Shopify.theme;
    if (t && t.role && t.role !== 'main' && t.id) url.searchParams.set('preview_theme_id', t.id);
    url.searchParams.set('sections', sid);
    url.searchParams.set('t', Date.now());
    return fetch(url.toString(), { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (json) {
        var html = json && json[sid];
        if (!html) throw new Error('sin seccion');
        var doc = new DOMParser().parseFromString(html, 'text/html');
        if (!doc.querySelector(DRAWER + ' .drawer__scrollable')) throw new Error('sin carrito');
        return doc;
      });
  }

  function applyDrawer(doc, form) {
    var state = doc.querySelector('template[data-jh-cart-state]');
    var cart = state ? JSON.parse(state.content.textContent) : null;
    var nextScroll = doc.querySelector(DRAWER + ' .drawer__scrollable');
    if (!nextScroll) return Promise.reject(new Error('Missing cart section'));
    return preload(nextScroll).then(function () {
      var curScroll = document.querySelector(DRAWER + ' .drawer__scrollable');
      var scrollTop = curScroll.scrollTop;
      morphChildren(curScroll, nextScroll);
      curScroll.scrollTop = scrollTop;
      if (removalCount) {
        var products = curScroll.querySelector('[data-products]');
        if (products) products.setAttribute('aria-busy', 'true');
      }
      ['[data-subtotal]', '[data-cart-discounts]', '[data-savings]', '[data-discounts]'].forEach(function (sel) {
        var a = document.querySelector(DRAWER + ' ' + sel);
        var b = doc.querySelector(DRAWER + ' ' + sel);
        if (a && b) morphChildren(a, b);
      });
      var count = curScroll.querySelectorAll('.cart__item').length;
      if (form && form.wrapper) form.wrapper.classList.toggle('is-empty', count === 0);
      if (form && form.reInit) form.reInit();
      function announce(value) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
          bubbles: true, detail: { cart: value, jhRendered: true }
        }));
      }
      if (cart) announce(cart);
      else if (window.theme && theme.cart && theme.cart.getCart) {
        return theme.cart.getCart().then(announce);
      }
    });
  }

  window.JherrCartSmooth = {
    idle: function () { return pending || Promise.resolve(); },
    renderSections: function (sections) {
      var html = sections && sections['jherr-cart-body'];
      if (!html) return Promise.reject(new Error('Missing cart section'));
      return applyDrawer(new DOMParser().parseFromString(html, 'text/html'), activeCartForm);
    }
  };

  function fastBuild(form) {
    var sid = sectionId();
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetchDrawer(root + 'cart', 'jherr-cart-body')
      .catch(function () {
        if (!sid) throw new Error('sin cabecera');
        return fetchDrawer(window.location.pathname, sid);
      })
      .then(function (doc) { return applyDrawer(doc, form); });
  }

  function removalBusy(on) {
    removalCount += on ? 1 : -1;
    var products = document.querySelector(DRAWER + ' [data-products]');
    if (products) {
      if (removalCount) products.setAttribute('aria-busy', 'true');
      else products.removeAttribute('aria-busy');
    }
    if (on && removalCount === 1) {
      checkoutState = Array.prototype.map.call(document.querySelectorAll(DRAWER + ' .cart__checkout'), function (button) {
        var state = { button: button, disabled: button.disabled };
        button.disabled = true;
        return state;
      });
    } else if (!removalCount) {
      checkoutState.forEach(function (state) { state.button.disabled = state.disabled; });
      checkoutState = [];
    }
  }

  function exitRow(row) {
    var originalStyle = row.getAttribute('style');
    var originalInert = row.hasAttribute('inert');
    var originalBusy = row.getAttribute('aria-busy');
    var quantity = row.querySelector('.js-qty__num');
    var originalQuantity = quantity && quantity.getAttribute('value');
    var height = row.getBoundingClientRect().height;
    var computed = getComputedStyle(row);
    var start = {
      boxSizing: 'border-box', overflow: 'hidden', minHeight: '0px',
      opacity: 1, transform: 'translateX(0)', height: height + 'px',
      paddingTop: computed.paddingTop, paddingBottom: computed.paddingBottom,
      marginTop: computed.marginTop, marginBottom: computed.marginBottom,
      borderTopWidth: computed.borderTopWidth, borderBottomWidth: computed.borderBottomWidth
    };
    var faded = Object.assign({}, start, { opacity: 0, transform: 'translateX(8px)', offset: 0.45 });
    var end = Object.assign({}, faded, {
      height: '0px', paddingTop: '0px', paddingBottom: '0px',
      marginTop: '0px', marginBottom: '0px', borderTopWidth: '0px', borderBottomWidth: '0px', offset: 1
    });
    row.setAttribute('inert', '');
    row.setAttribute('aria-busy', 'true');
    var animation = !reduce && row.animate ? row.animate([start, faded, end], {
      duration: 280, easing: 'cubic-bezier(.22,.68,.2,1)', fill: 'forwards'
    }) : null;
    if (!animation) row.style.display = 'none';
    return {
      done: animation ? animation.finished.catch(function () {}) : Promise.resolve(),
      restore: function () {
        if (animation) animation.cancel();
        if (originalStyle === null) row.removeAttribute('style'); else row.setAttribute('style', originalStyle);
        if (!originalInert) row.removeAttribute('inert');
        if (originalBusy === null) row.removeAttribute('aria-busy'); else row.setAttribute('aria-busy', originalBusy);
        if (quantity && originalQuantity !== null) quantity.value = originalQuantity;
      },
      cancel: function () { if (animation) animation.cancel(); }
    };
  }

  function removeRow(row) {
    var key = row.getAttribute('data-key');
    if (!key || removals.has(key)) return;
    var restoreFocus = row.contains(document.activeElement);
    var exit = exitRow(row);
    removals.set(key, exit);
    removalBusy(true);
    var error = document.querySelector(DRAWER + ' [data-jh-cart-change-error]');
    if (error) error.hidden = true;
    var announcement = document.querySelector(DRAWER + ' [data-jh-cart-removal-status]');
    if (announcement) announcement.textContent = '';
    var previous = pending || Promise.resolve();
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var request = previous.catch(function () {}).then(function () {
      return fetch(root + 'cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0, sections: ['jherr-cart-body'], sections_url: window.location.pathname })
      }).then(function (response) {
        return response.json().then(function (cart) {
          if (!response.ok || cart.status >= 400) throw new Error('Cart change failed');
          if (!Array.isArray(cart.items) || cart.items.some(function (item) { return item.key === key; })) throw new Error('Cart item still present');
          return cart;
        });
      });
    });
    var job = Promise.all([request, exit.done]).then(function (values) {
      return window.JherrCartSmooth.renderSections(values[0].sections).catch(function () {
        return fastBuild(activeCartForm);
      });
    }).then(function () {
      var status = document.querySelector(DRAWER + ' [data-jh-cart-removal-status]');
      if (status) status.textContent = status.getAttribute('data-removed-text');
      if (restoreFocus) {
        var next = Array.prototype.find.call(document.querySelectorAll(DRAWER + ' .cart__item:not([inert]) .js-qty__adjust--minus'), function (button) {
          return button.getClientRects().length;
        }) || document.querySelector(DRAWER + ' .drawer__close-button');
        if (next) next.focus({ preventScroll: true });
      }
    }).catch(function () {
      removals.delete(key);
      exit.restore();
      return fastBuild(activeCartForm).catch(function () {}).then(function () {
        var message = document.querySelector(DRAWER + ' [data-jh-cart-change-error]');
        if (message) message.hidden = false;
      });
    }).then(function () {
      removals.delete(key);
      exit.cancel();
      removalBusy(false);
      if (pending === job) pending = null;
    });
    pending = job;
    return job;
  }

  window.addEventListener('click', function (event) {
    var target = event.target.closest ? event.target : event.target.parentElement;
    var control = target && target.closest(DRAWER + ' .cart__remove a, ' + DRAWER + ' .js-qty__adjust--minus');
    if (!control) return;
    var row = control.closest('.cart__item');
    if (!row) return;
    var quantity = row.querySelector('.js-qty__num');
    if (control.classList.contains('js-qty__adjust--minus') && (!quantity || Number(quantity.value) !== 1)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    removeRow(row);
  }, true);

  window.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.matches(DRAWER + ' .js-qty__num') || !/^0+$/.test(input.value.trim())) return;
    var row = input.closest('.cart__item');
    if (!row) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    removeRow(row);
  }, true);

  function patchTheme() {
    if (!window.theme || !theme.CartForm || !theme.CartForm.prototype) return false;
    if (theme.CartForm.prototype.__jhSmooth) return true;

    /* Un solo juego de botones +/- por producto, aunque el carrito se redibuje */
    var OrigQty = theme.QtySelector;
    if (OrigQty && !OrigQty.__jhWrapped) {
      var Wrapped = function (el, options) {
        if (el.__jhQty) return el.__jhQty;
        var inst = new OrigQty(el, options);
        el.__jhQty = inst;
        return inst;
      };
      Wrapped.prototype = OrigQty.prototype;
      Wrapped.__jhWrapped = true;
      theme.QtySelector = Wrapped;
      /* Si el tema ya activó los botones del carrito, se marcan para no activarlos dos veces */
      if (theme.NavDrawer) {
        document.querySelectorAll(DRAWER + ' .js-qty__wrapper').forEach(function (el) { el.__jhQty = el.__jhQty || {}; });
      }
    }

    var proto = theme.CartForm.prototype;
    var origBuild = proto.buildCart;
    proto.__jhSmooth = true;
    proto.buildCart = function () {
      var self = this;
      if (!this.form || !this.form.closest || !this.form.closest(DRAWER)) return origBuild.apply(this, arguments);
      activeCartForm = self;
      if (renderedAddition) return Promise.resolve();
      /* Al cargar la página el carrito ya viene dibujado: no hace falta pedirlo otra vez */
      if (firstBuild && !recentEvent && document.readyState !== 'complete') { firstBuild = false; return; }
      firstBuild = false;
      if (pending) return pending;
      var job = fastBuild(self);
      var mine = job.catch(function () { return origBuild.apply(self); });
      pending = mine;
      mine.then(function () { if (pending === mine) pending = null; });
      return mine;
    };

    if (theme.AjaxProduct && !theme.AjaxProduct.prototype.__jhBundledCart) {
      var productProto = theme.AjaxProduct.prototype;
      var originalAdd = productProto.addItemFromForm;
      productProto.__jhBundledCart = true;
      productProto.addItemFromForm = function (event) {
        if (!this.form || !this.form.matches('form.product-single__form') || !document.body.classList.contains('template-product') || !document.querySelector(DRAWER)) {
          return originalAdd.apply(this, arguments);
        }
        event.preventDefault();
        if (pdpAdding) return;
        var self = this;
        var data = new FormData(this.form);
        data.set('sections', 'jherr-cart-body');
        data.set('sections_url', window.location.pathname);
        var button = this.addToCart;
        var oldBusy = button.getAttribute('aria-busy');
        button.classList.add('btn--loading');
        button.setAttribute('aria-busy', 'true');
        pdpAdding = true;
        var previous = pending || Promise.resolve();
        var needsRefresh = false;
        var job = previous.catch(function () {}).then(function () {
          var cartFetch = window.__JHCartOriginalFetch || window.fetch;
          return cartFetch(theme.routes.cartAdd, {
            method: 'POST', body: data, credentials: 'same-origin',
            headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }
          }).then(function (response) {
            return response.json().then(function (product) {
              if (!response.ok || product.status >= 400) throw product;
              return product;
            });
          });
        }).then(function (product) {
          return window.JherrCartSmooth.renderSections(product.sections).catch(function () {
            return fastBuild(activeCartForm);
          }).catch(function () {
            needsRefresh = true;
          }).then(function () {
            renderedAddition = !needsRefresh;
            try { self.success(product); } finally { renderedAddition = false; }
          });
        }).catch(function (error) {
          var drawer = document.querySelector(DRAWER);
          self.error({ description: error.description || drawer.getAttribute('data-jh-add-error'), message: error.message });
        });
        pending = job;
        var finish = function () {
          pdpAdding = false;
          button.classList.remove('btn--loading');
          if (oldBusy === null) button.removeAttribute('aria-busy'); else button.setAttribute('aria-busy', oldBusy);
          if (pending === job) pending = null;
          if (needsRefresh) document.dispatchEvent(new CustomEvent('cart:build'));
        };
        job.then(finish, finish);
        return job;
      };
    }

    /* El panel se abre cuando ya tiene el reloj nuevo (máximo 1,2 s de espera) */
    if (theme.CartDrawer && theme.CartDrawer.prototype && !theme.CartDrawer.prototype.__jhSmooth) {
      var dproto = theme.CartDrawer.prototype;
      var origOpen = dproto.open;
      dproto.__jhSmooth = true;
      dproto.open = function () {
        var self = this, args = arguments;
        var done = false;
        var go = function () {
          if (done) return;
          done = true;
          origOpen.apply(self, args);
        };
        if (!pending) return go();
        pending.then(go, go);
        setTimeout(go, 1200);
      };
    }
    /* El tema dibuja el carrito al cargar con otro formato (incluye productos técnicos ocultos).
       Se redibuja en silencio, con el panel cerrado, para que al abrirlo ya esté listo y no salte. */
    var quiet = function () {
      if (document.querySelector(DRAWER + ' [data-products] > .cart__items')) {
        document.dispatchEvent(new CustomEvent('cart:build'));
      }
    };
    var later = function () { setTimeout(quiet, 700); };
    if (document.readyState === 'complete') later(); else window.addEventListener('load', later, { once: true });
    return true;
  }

  if (!patchTheme()) document.addEventListener('DOMContentLoaded', patchTheme);
})();



